import script from "./StructuredDataWebPage.vue?vue&type=script&lang=js"
export * from "./StructuredDataWebPage.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__